import React from 'react';

const FeatureSplit = () => {
  return (
    <section className="bg-white py-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        
        {/* Flex Container: Changes direction based on screen size */}
        <div className="flex flex-col md:flex-row items-center gap-12">
          
          {/* Left Side: Image (Takes full width on mobile, half on desktop) */}
          <div className="w-full md:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                className="w-full h-[400px] object-cover transform hover:scale-105 transition-transform duration-700"
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
                alt="Team collaborating on a project"
              />
            </div>
            {/* Optional: Decorative background blob behind image */}
            <div className="absolute -z-10 top-0 -left-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
            <div className="absolute -z-10 bottom-0 -right-10 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
          </div>

          {/* Right Side: Content (Takes full width on mobile, half on desktop) */}
          <div className="w-full md:w-1/2 text-center md:text-left">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              Collaborate without limits
            </h2>
            <p className="mt-4 text-lg text-gray-500">
              Stop juggling multiple tools and spreadsheets. Our platform brings your team's communication, files, and tasks together in one simple interface. Boost productivity and focus on what really matters.
            </p>
            <div className="mt-8">
              <a
                href="#"
                className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 md:py-4 md:text-lg transition duration-150 ease-in-out shadow-md hover:shadow-lg"
              >
                Get Started for Free
                {/* Arrow Icon */}
                <svg className="ml-2 -mr-1 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
            
           
          </div>

        </div>
      </div>
    </section>
  );
};

export default FeatureSplit;